import React from 'react';
import Item from "../../components/list/Item";
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="Guide to Competitive Programming"
        desc="Learning and Improving Algorithms Through Contests"
        image="/images/books/guide-to-competitive-programming.jpg"
        pageType="book"
        author="Antti Laaksonen"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/guide-to-competitive-programming.jpg"
                width="400"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                Guide to Competitive Programming: Learning and Improving Algorithms Through Contests
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Antti Laaksonen</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Antti Laaksonen's guide is a hands-on introduction to the algorithms and data structures
                that power competitive programming. Covering topics from sorting and graph algorithms to
                number theory, geometry, and string processing, the book builds up your problem-solving
                toolkit one contest-tested technique at a time. Each chapter pairs clear explanations with
                practical examples drawn from real programming competitions, so you can immediately put
                what you learn into practice.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Whether you're preparing for coding interviews, looking to sharpen your algorithmic
                thinking, or aiming to compete in ICPC-style contests, this book offers a focused and
                accessible path. Join us as we work through the problems together and level up our
                algorithm skills.
              </p>

            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
